module.exports = __webpack_public_path__ + "static/media/Aloha-Friday-SJY-11-17-2017.996a34fc.jpg";